module.exports = __webpack_public_path__ + "img/wx.9a47d9aa.png";